import { all, call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import store from '../../store';
import { redirectToRelativeUrl } from '../entities/organizations/actions';
import { facebook as facebookApi } from '../../../api/modules';
import * as actions from './actions';
import * as service from './service';

export function * fbLogout () {
    try {
        yield call(service.logout);
    } catch (error) {
        console.error(error);
    }
}

export function * watchFbLogout () {
    yield takeEvery(actions.FB_LOGOUT, fbLogout);
}

export function * fbLogin (action) {

    const { response } = action.payload;

    try {
        if (response.authResponse) {
            const { accessToken } = response.authResponse;
            const profile = yield call(service.getUser);
            yield put(actions.facebookLoginSuccess(accessToken, profile.id, profile.first_name, profile.picture.data.url));
        }
    } catch (error) {
        yield put(actions.facebookLoginFailure('Couldn\'t login to Facebook'));

    }
}

export function * watchFbLogin () {
    yield takeEvery(actions.FB_LOGIN, fbLogin);
}

export function * getPages () {
    try {
        const pages = yield call(service.getPages);
        yield put(actions.getPagesSuccess(pages));
    } catch (error) {
        yield put(actions.getPagesFailure('Couldn\'t get user pages'));
    }
}

export function * watchGetPages () {
    yield takeEvery(actions.GET_PAGES, getPages);
}

export function * parseXfbml () {
    try {
        const pages = yield call(service.parseXFBML);
        yield put(actions.parseXfbmlSuccess(pages));
    } catch (error) {
        yield put(actions.parseXfbmlFailure('Couldn\'t parse XFBML'));

    }
}

export function * watchParseXfbml () {
    yield takeEvery(actions.PARSE_XFBML, parseXfbml);
}

function injectFacebookSDK () {
    return new Promise((resolve, reject) => {
        try {
            const d = window.document;
            const s = 'script';
            const id = 'facebook-jssdk';

            if (!d.getElementById(id)) {
                const fjs = d.getElementsByTagName(s)[0];
                const js = d.createElement(s);
                js.id = id;
                js.src = 'https://connect.facebook.net/en_US/sdk.js';
                js.onload = resolve;
                js.onerror = reject;
                fjs.parentNode.insertBefore(js, fjs);
            } else {
                console.warn('Facebook SDK script already injected');
                resolve();
            }
        } catch (e) {
            reject(e);
        }
    });
}

function initFacebookSDK () {
    window.FB.init({
        appId: process.env.REACT_APP_FACEBOOK_APP_ID,
        status: false,
        cookie: false,
        xfbml: false,
        version: 'v16.0'
    });

    window.FB.Event.subscribe('auth.statusChange', r => store.dispatch(actions.facebookLogin(r)));
}

export function * loadFacebookSDK () {
    try {
        yield call(injectFacebookSDK);
        yield call(initFacebookSDK);
        yield put(actions.loadFacebookSDKSuccess());
    } catch (error) {
        yield put(actions.loadFacebookSDKFailure('Error loading Facebook SDK'));
    }
}

export function * watchLoadFacebookSDK () {
    yield takeEvery(actions.LOAD_FACEBOOK_SDK, loadFacebookSDK);
}

export function * connectIgBusinessAccount (action) {
    const { organizationId, shorLivedToken, pageId } = action.payload;

    try {
        const { successful, response, error, status, message } = yield call(facebookApi.connectIgBusinessAccount, organizationId, shorLivedToken, pageId);
        if (!!error) {
            throw error;
        }
        if (!successful) {
            const conectionError = new Error(message);
            conectionError.status = status;
            throw conectionError;
        }
        yield put(actions.connectIgBusinessAccountSuccess(organizationId, response));
        yield put(actions.facebookLogout());
        yield put(redirectToRelativeUrl(`/content`));
    } catch (error) {
        yield put(actions.connectIgBusinessAccountFailure(organizationId, error?.status));
    }
}

export function * watchConnectIgBusinessAccount () {
    yield takeEvery(actions.CONNECT_IG_BUSINESS_ACCOUNT, connectIgBusinessAccount);
}

export function * getIgBusinessAccount (action) {
    const { organizationId, includeParents } = action.payload;

    try {
        const { error, response } = yield call(facebookApi.getIgBusinessAccounts, organizationId, includeParents);
        if (!!error) {
            throw new Error(error);
        }
        yield put(actions.getIgBusinessAccountsSuccess(organizationId, response));
    } catch (error) {
        const message = 'Couldn\'t connect Instagram Business Account';
        yield call(toast.error, message);
        yield put(actions.getIgBusinessAccountsFailure(organizationId, { message, error }));
    }
}

export function * watchGetIgBusinessAccount () {
    yield takeEvery(actions.GET_IG_BUSINESS_ACCOUNTS, getIgBusinessAccount);
}

export function * disconnectIgBusinessAccount (action) {
    const { organizationId, pageId } = action.payload;

    try {
        const { error, successful, message } = yield call(facebookApi.disconnectIgBusinessAccount, organizationId, pageId);
        if (!!error) {
            throw error;
        }
        if (!successful) {
            throw new Error(message);
        }
        yield put(actions.disconnectIgBusinessAccountSuccess(organizationId, successful));
        yield put(actions.getIgBusinessAccounts(organizationId, false));
    } catch (error) {
        yield put(actions.disconnectIgBusinessAccountFailure(organizationId, error));
    }
}

export function * watchDisconnectIgBusinessAccount () {
    yield takeEvery(actions.DISCONNECT_IG_BUSINESS_ACCOUNT, disconnectIgBusinessAccount);
}

export default function * rootSaga () {
    yield all([
        watchFbLogin(),
        watchGetPages(),
        watchParseXfbml(),
        watchLoadFacebookSDK(),
        watchConnectIgBusinessAccount(),
        watchGetIgBusinessAccount(),
        watchFbLogout(),
        watchDisconnectIgBusinessAccount(),
    ]);
};